import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addFcmTokenLoading: false,
  addFcmTokenData: null,
  addFcmTokenError: null,

  getAppLoadDataLoading: false,
  getAppLoadDataSuccess: false,
  getAppLoadDataError: null,

  getEmojiCategoryLoading: false,
  getEmojiCategoryData: null,
  getEmojiCategoryError: null,

  getMusicsLoading: false,
  getMusicsData: null,
  getMusicsError: null,

  getFontsLoading: false,
  getFontsData: null,
  getFontsError: null,

  generateVideoLoading: false,
  generateVideoData: null,
  generateVideoError: null,

  getTemplateCategoriesLoading: false,
  getTemplateCategoriesData: null,
  getTemplateCategoriesError: null,

  getTemplateByCategoryLoading: false,
  getTemplateByCategoryData: null,
  getTemplateByCategoryError: null,

  getTemplateByIdLoading: false,
  getTemplateByIdData: null,
  getTemplateByIdError: null,

  updateCreatedInvitationInfoLoading: false,
  updateCreatedInvitationInfoData: null,
  updateCreatedInvitationInfoError: null,

  getCreatedInvitationsLoading: false,
  getCreatedInvitationsData: null,
  getCreatedInvitationsError: null,
  createdRemoveInvitationsAfter: null,
  createdFreeInvitationsTotal: null,
  createdPaidInvitationsTotal: null,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    addFcmTokenRequest: (state) => {
      state.addFcmTokenLoading = true;
      state.addFcmTokenData = null;
      state.addFcmTokenError = null;
    },
    addFcmTokenSuccess: (state, action) => {
      state.addFcmTokenLoading = false;
      state.addFcmTokenData = action.payload;
    },
    addFcmTokenFailure: (state, action) => {
      state.addFcmTokenLoading = false;
      state.addFcmTokenError = action.payload;
    },
    addFcmTokenClear(state) {
      state.addFcmTokenLoading = true;
      state.addFcmTokenData = null;
      state.addFcmTokenError = null;
    },

    getAppLoadDataRequest: (state) => {
      state.getAppLoadDataLoading = true;
      state.getAppLoadDataError = null;
    },
    getAppLoadDataSuccess: (state, action) => {
      state.getAppLoadDataLoading = false;
      state.getAppLoadDataSuccess = action.payload;
    },
    getAppLoadDataFailure: (state, action) => {
      state.getAppLoadDataLoading = false;
      state.getAppLoadDataError = action.payload;
    },

    getEmojiCategoryRequest: (state) => {
      state.getEmojiCategoryLoading = true;
      state.getEmojiCategoryError = null;
    },
    getEmojiCategorySuccess: (state, action) => {
      state.getEmojiCategoryLoading = false;
      state.getEmojiCategoryData = action.payload;
    },
    getEmojiCategoryFailure: (state, action) => {
      state.getEmojiCategoryLoading = false;
      state.getEmojiCategoryError = action.payload;
    },
    getEmojiCategoryDataClear: (state) => {
      state.getEmojiCategoryLoading = false;
      state.getEmojiCategoryData = null;
      state.getEmojiCategoryError = null;
    },

    getMusicsRequest: (state) => {
      state.getMusicsLoading = true;
      state.getMusicsError = null;
    },
    getMusicsSuccess: (state, action) => {
      state.getMusicsLoading = false;
      state.getMusicsData = action.payload;
    },
    getMusicsFailure: (state, action) => {
      state.getMusicsLoading = false;
      state.getMusicsError = action.payload;
    },
    getMusicsDataClear: (state) => {
      state.getMusicsLoading = false;
      state.getMusicsData = null;
      state.getMusicsError = null;
    },

    getFontsRequest: (state) => {
      state.getFontsLoading = true;
      state.getFontsError = null;
    },
    getFontsSuccess: (state, action) => {
      state.getFontsLoading = false;
      state.getFontsData = action.payload;
    },
    getFontsFailure: (state, action) => {
      state.getFontsLoading = false;
      state.getFontsError = action.payload;
    },
    getFontsDataClear: (state) => {
      state.getFontsLoading = false;
      state.getFontsData = null;
      state.getFontsError = null;
    },

    generateVideoRequest: (state) => {
      state.generateVideoLoading = true;
      state.generateVideoError = null;
    },
    generateVideoSuccess: (state, action) => {
      state.generateVideoLoading = false;
      state.generateVideoData = action.payload;
    },
    generateVideoFailure: (state, action) => {
      state.generateVideoLoading = false;
      state.generateVideoError = action.payload;
    },
    generateVideoDataClear: (state) => {
      state.generateVideoLoading = false;
      state.generateVideoData = null;
      state.generateVideoError = null;
    },

    getTemplateCategoriesRequest: (state) => {
      state.getTemplateCategoriesLoading = true;
      state.getTemplateCategoriesError = null;
    },
    getTemplateCategoriesSuccess: (state, action) => {
      state.getTemplateCategoriesLoading = false;
      state.getTemplateCategoriesData = action.payload;
    },
    getTemplateCategoriesFailure: (state, action) => {
      state.getTemplateCategoriesLoading = false;
      state.getTemplateCategoriesError = action.payload;
    },
    getTemplateCategoriesDataClear: (state) => {
      state.getTemplateCategoriesLoading = false;
      state.getTemplateCategoriesData = null;
      state.getTemplateCategoriesError = null;
    },

    getTemplateByCategoryRequest: (state) => {
      state.getTemplateByCategoryLoading = true;
      state.getTemplateByCategoryError = null;
    },
    getTemplateByCategorySuccess: (state, action) => {
      state.getTemplateByCategoryLoading = false;
      state.getTemplateByCategoryData = action.payload;
    },
    getTemplateByCategoryFailure: (state, action) => {
      state.getTemplateByCategoryLoading = false;
      state.getTemplateByCategoryError = action.payload;
    },
    getTemplateByCategoryDataClear: (state) => {
      state.getTemplateByCategoryLoading = false;
      state.getTemplateByCategoryData = null;
      state.getTemplateByCategoryError = null;
    },

    getTemplateByIdRequest: (state) => {
      state.getTemplateByIdLoading = true;
      state.getTemplateByIdError = null;
    },
    getTemplateByIdSuccess: (state, action) => {
      state.getTemplateByIdLoading = false;
      state.getTemplateByIdData = action.payload;
    },
    getTemplateByIdFailure: (state, action) => {
      state.getTemplateByIdLoading = false;
      state.getTemplateByIdError = action.payload;
    },
    getTemplateByIdDataClear: (state) => {
      state.getTemplateByIdLoading = false;
      state.getTemplateByIdData = null;
      state.getTemplateByIdError = null;
    },

    updateCreatedInvitationInfoRequest: (state) => {
      state.updateCreatedInvitationInfoLoading = true;
      state.updateCreatedInvitationInfoError = null;
    },
    updateCreatedInvitationInfoSuccess: (state, action) => {
      state.updateCreatedInvitationInfoLoading = false;
      state.updateCreatedInvitationInfoData = action.payload;
    },
    updateCreatedInvitationInfoFailure: (state, action) => {
      state.updateCreatedInvitationInfoLoading = false;
      state.updateCreatedInvitationInfoError = action.payload;
    },
    updateCreatedInvitationInfoDataClear: (state) => {
      state.updateCreatedInvitationInfoLoading = false;
      state.updateCreatedInvitationInfoData = null;
      state.updateCreatedInvitationInfoError = null;
    },

    getCreatedInvitationsRequest: (state) => {
      state.getCreatedInvitationsLoading = true;
      state.getCreatedInvitationsData = null;
      state.getCreatedInvitationsError = null;
    },
    getCreatedInvitationsSuccess: (state, action) => {
      state.getCreatedInvitationsLoading = false;

      const payload = action.payload || {};

      state.getCreatedInvitationsData = payload?.invitations || [];

      state.createdRemoveInvitationsAfter = payload?.remove_after_days || {};
      state.createdFreeInvitationsTotal = payload?.free_total || 0;
      state.createdPaidInvitationsTotal = payload?.paid_total || 0;
    },
    getCreatedInvitationsFailure: (state, action) => {
      state.getCreatedInvitationsLoading = false;
      state.getCreatedInvitationsError = action.payload;
    },
    getCreatedInvitationsDataClear: (state) => {
      state.getCreatedInvitationsLoading = false;
      state.getCreatedInvitationsData = null;
      state.getCreatedInvitationsError = null;
    },
  }
});

export const { 
  addFcmTokenRequest, addFcmTokenSuccess, addFcmTokenFailure, addFcmTokenClear,
  getAppLoadDataRequest, getAppLoadDataSuccess, getAppLoadDataFailure,
  getEmojiCategoryRequest, getEmojiCategorySuccess, getEmojiCategoryFailure, getEmojiCategoryDataClear,
  getMusicsRequest, getMusicsSuccess, getMusicsFailure, getMusicsDataClear,
  getFontsRequest, getFontsSuccess, getFontsFailure, getFontsDataClear,
  generateVideoRequest, generateVideoSuccess, generateVideoFailure, generateVideoDataClear,
  getTemplateCategoriesRequest, getTemplateCategoriesSuccess, getTemplateCategoriesFailure, getTemplateCategoriesDataClear,
  getTemplateByCategoryRequest, getTemplateByCategorySuccess, getTemplateByCategoryFailure, getTemplateByCategoryDataClear,
  getTemplateByIdRequest, getTemplateByIdSuccess, getTemplateByIdFailure, getTemplateByIdDataClear,
  updateCreatedInvitationInfoRequest, updateCreatedInvitationInfoSuccess, updateCreatedInvitationInfoFailure, updateCreatedInvitationInfoDataClear,
  getCreatedInvitationsRequest, getCreatedInvitationsSuccess, getCreatedInvitationsFailure, getCreatedInvitationsDataClear,
} = appSlice.actions;

export default appSlice.reducer;